export const GET_FOOTER = "GET_FOOTER";
export const GET_FOOTER_LOADING = "GET_FOOTER_LOADING";
